// extracted by mini-css-extract-plugin
export default {"section":"SidebarSection_section__ecFJW","sidebar":"SidebarSection_sidebar__wAT4w","label":"SidebarSection_label__bbopu","visible":"SidebarSection_visible__WXU18"};